import { UpsaleButton } from '../UpsaleButton/UpsaleButton';
import styles from './UpsellConfirm.module.scss';

// The confirm step of a recurring upsell (QA-98): the price again, how often it renews, a separate pay button.
export const UpsellConfirm = ({ text, onConfirm, onCancel, className }) => (
  <div className={className} role="dialog" aria-live="polite" data-testid="upsell-confirm">
    <div className={styles.text}>{text}</div>
    <UpsaleButton onClick={onConfirm} data-testid="upsell-confirm-pay">
      Confirm and pay
    </UpsaleButton>
    <button type="button" className={styles.cancel} onClick={onCancel}>
      Not now
    </button>
  </div>
);
